module.exports = __webpack_public_path__ + "static/media/vr.15310b62.jpg";